"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { SunIcon } from "@/app/components/icons/SunIcon";
import { MoonIcon } from "@/app/components/icons/MoonIcon";

export default function ThemeSwitcher() {
  const [mounted, setMounted] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { theme, setTheme } = useTheme();

  // Avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    // Placeholder with same styles as real button to prevent layout shift
    return (
      <button className="flex items-center justify-center p-2 rounded-[5px]">
        <div className="w-[18px] h-[18px]" />
      </button>
    );
  }

  return (
    <button
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="flex items-center justify-center p-2 rounded-[5px] hover:bg-gray-100 dark:hover:bg-[#18181D] transition-colors"
      aria-label="Toggle theme"
    >
      {theme === "dark" ? (
        <SunIcon size={18} className="text-gray-500 dark:text-gray-400" />
      ) : (
        <MoonIcon size={18} className="text-gray-500 dark:text-gray-400" />
      )}
    </button>
  );
}
